import React, { memo, useCallback, useState } from 'react';

import { Box, IconButton } from '@mui/material';
import { CancelIcon } from '@sharedCR/coreDesignSystem/icons';
import SecondaryTabGroupCDS from '@sharedCR/coreDesignSystem/SecondaryTabGroupCDS';
import PropTypes from 'prop-types';

import { IconSize } from 'constants/coreDesignSystem';

import { BorrowersTestIds } from '../../Borrowers.testIds';
import { CONTACT_PANEL_TAB, CONTACT_PANEL_TAB_BUTTONS } from '../CrmContactSection.constants';

import CreateContactPanel from './CreateContactPanel';
import FindContactPanel from './FindContactPanel';
import { bodyStyles, closeButtonStyles, headerStyles, panelStyles } from './FindCreatePanel.styles';

const FindCreatePanel = ({ borrower, onContactChosen, onClose }) => {
  const [tab, setTab] = useState(CONTACT_PANEL_TAB.FIND);

  const onTabChange = useCallback(value => setTab(value), []);

  return (
    <Box sx={panelStyles}>
      <Box sx={headerStyles}>
        <Box flex={1}>
          <SecondaryTabGroupCDS
            buttons={CONTACT_PANEL_TAB_BUTTONS}
            value={tab}
            onChange={onTabChange}
          />
        </Box>
        <IconButton
          aria-label="Close"
          data-testid={BorrowersTestIds.CONTACT_PANEL_CLOSE_BUTTON}
          sx={closeButtonStyles}
          title="Close"
          onClick={onClose}
        >
          <CancelIcon size={IconSize[20]} />
        </IconButton>
      </Box>

      <Box sx={bodyStyles}>
        {tab === CONTACT_PANEL_TAB.FIND ? (
          <FindContactPanel borrower={borrower} onContactChosen={onContactChosen} />
        ) : (
          <CreateContactPanel borrower={borrower} onCreated={onContactChosen} />
        )}
      </Box>
    </Box>
  );
};

FindCreatePanel.propTypes = {
  borrower: PropTypes.shape({ id: PropTypes.string }).isRequired,
  onClose: PropTypes.func.isRequired,
  onContactChosen: PropTypes.func.isRequired,
};

export default memo(FindCreatePanel);
